import React from "react";
import {
	DataHeading,
	BlurContainer,
	DataValue,
	ItalicData,
	WordBreakDataValue,
	BlurOverlay
} from "../../../../CommonComponents/commonStyles";
import CSREditLinkToPill from "../../../../CommonComponents/EditLinkToPill/CSREditLinkToPill";
import {
	AdditionalAccountInfoContainer,
	AccountIdentifierContainer,
	SegmentationContainer,
	BookOfBusinessContainer,
	AccountNotesContainer,
	CSREditLinkToPillContainer,
	DataContainer,
	EditContainer
} from "./styles";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import moment from "moment";
import { checkCSRBusinessFunction } from "../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../CSR/utils/csrBusinessFunctionMapper";

export function AccountIdentifier(props){
	const disabled = checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_ACC_IDENTIFIER_FULL_ACCESS'], props.csrBusinessFunction);
	return (
		<AccountIdentifierContainer>
			<DataContainer>
				<DataHeading> Account Identifier: </DataHeading>
				<DataValue> {props.accountIdentifier ? props.accountIdentifier : '—' } </DataValue>
				<ItalicData> {props.identifierAssignedDate ? moment(new Date(props.identifierAssignedDate)).format("MM/DD/YYYY") : '—' } </ItalicData>
				<WordBreakDataValue><ItalicData> {props.identifierNotes ? props.identifierNotes : '—' } </ItalicData></WordBreakDataValue>
			</DataContainer>
			<EditContainer>
				<CSREditLinkToPillContainer>
					<CSREditLinkToPill
						disabled={ disabled }
						toGeminiApp={true}
						linkPathname={`/vceptpl/csr/acctmaint/editIdentifiersForAccount.do?dafAccountId=${getPrimaryAccount()?.userId}`}
					/>
				</CSREditLinkToPillContainer>
			</EditContainer>
		</AccountIdentifierContainer>
		)
}

export function Segmentation(props){
	const disabled = checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_SEGMENATION_FULL_ACCESS'], props.csrBusinessFunction);
	return (
		<SegmentationContainer>
			<DataContainer>
				<DataHeading> Segmentation: </DataHeading>
				<DataValue> {props.segmentation ? props.segmentation : '—' } </DataValue>
			</DataContainer>
			<EditContainer>
				<CSREditLinkToPillContainer>
					<CSREditLinkToPill 
						disabled={ disabled }
						toGeminiApp={true}
						linkPathname={`/vceptpl/csr/acctmaint/editAccountSegmentation.do?dafAccountId=${getPrimaryAccount()?.userId}`}
					/>
				</CSREditLinkToPillContainer>
			</EditContainer>
		</SegmentationContainer>
		)
}

export function BookOfBusiness(props){
	const disabled = checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_BOOK_OF_BUSINESS_FULL_ACCESS'], props.csrBusinessFunction);
	return (
		<BookOfBusinessContainer>
			<DataContainer>
				<DataHeading>Book of Business:</DataHeading>
				<DataValue> {props.bookOfBusiness ? props.bookOfBusiness : '—' } </DataValue>
			</DataContainer>
			<EditContainer>
				<CSREditLinkToPillContainer>
					<CSREditLinkToPill
						disabled={ disabled }
						toGeminiApp={true}
						linkPathname={`/vceptpl/csr/acctmaint/editAccountBookOfBusiness.do?dafAccountId=${getPrimaryAccount()?.userId}`}
					/>
				</CSREditLinkToPillContainer>
			</EditContainer>
		</BookOfBusinessContainer>
		)
}

export function AccountNotes(props){
	const disabled = checkCSRBusinessFunction(BUSINESS_FUNCTION['DONOR_PORTAL_ACC_NOTES_FULL_ACCESS'], props.csrBusinessFunction);
	return (
		<AccountNotesContainer>
			<DataContainer>
				<DataHeading>Account Notes:</DataHeading>
				<WordBreakDataValue> {props.accountNotes ? props.accountNotes : '—' } </WordBreakDataValue>
			</DataContainer>
			<EditContainer>
				<CSREditLinkToPillContainer>
					<CSREditLinkToPill
						disabled={ disabled }
						toGeminiApp={true}
						linkPathname={`/vceptpl/csr/acctmaint/editAccountNotes.do?dafAccountId=${getPrimaryAccount()?.userId}`}
					/>
				</CSREditLinkToPillContainer>
			</EditContainer>
		</AccountNotesContainer>
		)
}

 function AdditionalAccountInfoForGemini(props) {
	const {
		accountIdentifier,
		segmentation,
		bookOfBusiness,
		accountNotes,
		identifierAssignedDate,
		identifierNotes
	} = props.navBarData;
	
	return (
		<BlurContainer className="gemini-acc-info-container">
			<BlurOverlay isEnabled={props.blur} />
			<AdditionalAccountInfoContainer >
				<AccountIdentifier accountIdentifier={accountIdentifier} identifierAssignedDate={identifierAssignedDate} identifierNotes={identifierNotes} csrBusinessFunction={props.csrBusinessFunction}/>
				<Segmentation segmentation={segmentation} csrBusinessFunction={props.csrBusinessFunction}/>
				<BookOfBusiness bookOfBusiness={bookOfBusiness} csrBusinessFunction={props.csrBusinessFunction}/>
				<AccountNotes accountNotes={accountNotes} csrBusinessFunction={props.csrBusinessFunction}/>
			</AdditionalAccountInfoContainer >
		</BlurContainer>
	);
}

export default AdditionalAccountInfoForGemini;